import { ApiResponse } from "../../types";
import { apiClient } from "../client";

export interface CheckoutResolutionParams {
  dbName: string;
  date: string;
}

export interface CheckoutResolutionData {
  ops: string;
  valor_compra: number;
  pagamentos_unicos: number;
  data_romaneio: string;
  status?: string;
}

export interface CheckoutResolutionResponse {
  pending: CheckoutResolutionData[];
  resolved: CheckoutResolutionData[];
  summary: {
    totalPending: number;
    totalResolved: number;
    totalValue: number;
  };
}

export interface ResolveCheckoutParams {
  ops: string;
  dbName: string;
  date: string;
}

export interface CheckoutListParams {
  dbName: string;
  ops: string;
}

export interface CheckoutListItem {
  ops: string;
  date_to_checkout: string;
  entregadores_unicos?: number;
  entregadores_unicos_cadastrados?: number;
  ticket_medio: number;
  total_valor_face: number;
  status: string;
}

export const checkoutService = {
  async getResolutionData(
    params: CheckoutResolutionParams
  ): Promise<ApiResponse<CheckoutResolutionResponse>> {
    return apiClient.post("/checkoutResolution", params);
  },

  async resolveCheckout(
    params: ResolveCheckoutParams
  ): Promise<ApiResponse> {
    return apiClient.post("/resolveCheckout", params);
  },

  async getCheckoutList(
    params: CheckoutListParams
  ): Promise<ApiResponse<CheckoutListItem[]>> {
    return apiClient.post("/gestorCheckoutList", params);
  },
};
